import { useMutation, useRedirect, useNotify } from 'react-admin';

const customCreate = ({ basePath, resourceText, createdText }) => {
  const [mutate] = useMutation();
  const redirect = useRedirect();
  const notify = useNotify();
  const create = async (values) => {
    const formattedValues = values;
    console.log('VALUEEES', values);
    formattedValues.clientId = values.clientId.id;
    try {
      await mutate(
        {
          type: 'create',
          resource: 'courses',
          payload: { id: values.id, data: formattedValues },
        },
        { returnPromise: true }
      );
      redirect('list', basePath);
      notify(`${resourceText} ${values.name} ${createdText}`, 'success');
    } catch (error) {
      if (error.body.errors) {
        notify(error.body.errors, 'error');
        return error.body.errors;
      }
    }
  };
  return create;
};

export default customCreate;
